const React = require('react');
const AppProviders = require('./src/providers/AppProviders').default;

exports.wrapRootElement = ({ element }) =>
  React.createElement(AppProviders, null, element);

// Notify when route changes to update country context
exports.onRouteUpdate = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('gatsby-route-change'));
  }
};
